var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-row',{staticClass:"pa-0 fill-height",attrs:{"no-gutters":""}},[_c('v-tabs-items',{staticClass:"fill-height",staticStyle:{"width":"100%"},attrs:{"touchless":""},model:{value:(_vm.tab),callback:function ($$v) {_vm.tab=$$v},expression:"tab"}},[_c('v-tab-item',{staticClass:"fill-height",attrs:{"value":"tab-1"}},[_c('attendances-crud')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }